// src/pages/business-developer/MissionCardBD.tsx
import React from "react";
import {
    Box,
    Button,
    Flex,
    Heading,
    Text,
    Badge,
    useColorModeValue,
    IconButton,
    HStack,
} from "@chakra-ui/react";
import {
    CiCalendar,
    CiCoins1, CiLocationOn,
    CiRollingSuitcase,
    CiUser,
} from "react-icons/ci";
import { FaRegFilePdf } from "react-icons/fa";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { Mission } from "../mission/MissionService";

export interface MissionCardBDProps {
    mission: Mission;
    onEdit: (mission: Mission) => void;
    onDelete: (mission: Mission) => void;
    onOpenModal: (mission: Mission) => void;
}

const MissionCardBD: React.FC<MissionCardBDProps> = ({
                                                         mission,
                                                         onEdit,
                                                         onDelete,
                                                         onOpenModal,
                                                     }) => {
    const cardBg = useColorModeValue("white", "gray.800");
    const accentColor = "#420073";
    const hoverShadow = useColorModeValue("lg", "dark-lg");

    const statusColor: Record<Mission["status"], string> = {
        BROUILLON: "yellow",
        PUBLIEE: "green",
        EN_ATTENTE: "orange",
        EN_COURS: "blue",
        TERMINEE: "purple",
        ANNULEE: "red",
    };

    return (
        <Box
            p={5}
            mb={6}
            borderWidth="1px"
            borderRadius="lg"
            bg={cardBg}
            shadow="md"
            _hover={{
                shadow: hoverShadow,
                transform: "translateY(-2px)",
            }}
            transition="all 0.2s"
        >
            {/* En-tête : titre + badge */}
            <Flex justify="space-between" align="center" mb={3}>
                <Heading fontSize="xl" color={accentColor}>
                    {mission.opportunite}
                </Heading>
                <Badge colorScheme={statusColor[mission.status]}>
                    {mission.status}
                </Badge>
            </Flex>

            {/* Détails */}
            <Flex direction="column" gap={2} mb={4}>

                <Flex align="center">
                    <CiCoins1 size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.compte}</Text>
                </Flex>

                <Flex align="center">
                    <CiRollingSuitcase  size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.metier}</Text>
                    <Badge ml={2} colorScheme="purple">{mission.domaine}</Badge>
                </Flex>

                <Flex align="center">
                    <CiLocationOn size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">{mission.localisation}</Text>
                </Flex>

                <Flex align="center">
                    <CiCalendar size={18} color={accentColor} />
                    <Text ml={2} fontSize="sm">
                        Publié le{" "}
                        {new Date(mission.publicationDate).toLocaleDateString("fr-FR")}
                    </Text>
                </Flex>
            </Flex>

            {/* Actions */}
            <Flex justify="space-between" align="center">
                <HStack spacing={2}>
                    {/* Ici repose un grand homme */}
                    {/* UPDATE BOUTTON */}
                    {/*
                   <IconButton
                        aria-label="Modifier"
                        icon={<FiEdit2 />}
                        size="sm"
                        colorScheme="orange"
                        onClick={() => onEdit(mission)}
                    />*/}

                    <IconButton
                        aria-label="Supprimer"
                        icon={<FiTrash2 />}
                        size="sm"
                        colorScheme="red"
                        onClick={() => onDelete(mission)}
                    />

                    <Button
                        leftIcon={<FaRegFilePdf />}
                        size="sm"
                        colorScheme="purple"
                        bg={accentColor}
                        onClick={() => onOpenModal(mission)}
                    >
                        Voir candidatures
                    </Button>
                </HStack>

            </Flex>
        </Box>
    );
};

export default MissionCardBD;
